import React from 'react'
import { Routes, Route } from 'react-router-dom'
import styled from 'styled-components'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import Home from './pages/Home'
import Guide from './pages/Guide'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Cookies from './pages/Cookies'
import Projects from './pages/Projects'
import RequestProject from './pages/RequestProject'
import Whitepaper from './pages/Whitepaper'
import API from './pages/API'
import DemoMode from './components/DemoMode'

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-background);
  color: var(--color-text);
`

const MainContent = styled.main`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`

const FooterWrapper = styled.div`
  flex-shrink: 0;
  position: relative;
  z-index: 10;
`

function App() {
  return (
    <AppContainer>
      <DemoMode />
      <Navigation />
      <MainContent>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/request" element={<RequestProject />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route path="/api" element={<API />} />
        </Routes>
      </MainContent>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </AppContainer>
  )
}

export default App
